import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { SITE, waLink } from "@/data/site";

export function Footer() {
  return (
    <footer className="bg-[#361E02] text-[#F9EFE1]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 lg:py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="font-display text-3xl font-semibold text-white">VacanzaGo</div>
          <p className="mt-1 eyebrow text-[#D4AF37]">Travel · Events · Experiences</p>
          <p className="mt-5 text-sm leading-relaxed text-[#F9EFE1]/70">
            Haridwar's pilgrimage and Himalayan tour operator since {SITE.since}. You don't have to
            worry about anything once we take over.
          </p>
        </div>

        <div>
          <h4 className="font-display text-xl text-[#D4AF37] mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm text-[#F9EFE1]/80">
            <li><Link to="/packages" className="hover:text-[#F49E1A]">Journeys</Link></li>
            <li><Link to="/destinations" className="hover:text-[#F49E1A]">Destinations</Link></li>
            <li><Link to="/recommender" className="hover:text-[#F49E1A]">Plan My Journey</Link></li>
            <li><Link to="/events" className="hover:text-[#F49E1A]">Event Management</Link></li>
            <li><Link to="/corporate" className="hover:text-[#F49E1A]">Corporate & B2B</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-xl text-[#D4AF37] mb-4">Company</h4>
          <ul className="space-y-2.5 text-sm text-[#F9EFE1]/80">
            <li><Link to="/about" className="hover:text-[#F49E1A]">About Us</Link></li>
            <li><Link to="/blog" className="hover:text-[#F49E1A]">Journal</Link></li>
            <li><Link to="/faqs" className="hover:text-[#F49E1A]">FAQs</Link></li>
            <li><Link to="/policies" className="hover:text-[#F49E1A]">Policies</Link></li>
            <li><Link to="/contact" className="hover:text-[#F49E1A]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-xl text-[#D4AF37] mb-4">Reach us</h4>
          <ul className="space-y-3 text-sm text-[#F9EFE1]/80">
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 shrink-0 text-[#F49E1A]" /> {SITE.city}</li>
            <li className="flex items-center gap-3"><Phone size={16} className="text-[#F49E1A]" /> <a href={`tel:${SITE.phoneRaw}`} className="hover:text-[#F49E1A]">{SITE.phone}</a></li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-[#F49E1A]" /> <a href={`mailto:${SITE.email}`} className="hover:text-[#F49E1A]">{SITE.email}</a></li>
            <li>
              <a href={waLink()} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-2 rounded-full bg-[#F49E1A] text-[#361E02] px-4 py-2 font-semibold text-xs">
                <MessageCircle size={14} /> WhatsApp us
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#F9EFE1]/50">
          <span>© {new Date().getFullYear()} VacanzaGo. All rights reserved.</span>
          <Link to="/admin/login" className="hover:text-[#F49E1A]" data-testid="footer-admin-link">Staff Login</Link>
        </div>
      </div>
    </footer>
  );
}
